module.exports = __webpack_public_path__ + "static/img/cp_icon_B07.710898e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/cp_icon_B07.png
// module id = x2zZ
// module chunks = 1